import { render } from "./search-map.vue?vue&type=template&id=b3056524"
import script from "./search-map.vue?vue&type=script&lang=js"
export * from "./search-map.vue?vue&type=script&lang=js"

import "./search-map.vue?vue&type=style&index=0&id=b3056524&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/template4/search-map.vue'],['render',render],['__file',"search-map.vue"]])

export default __exports__